import { stVars } from '../Foundation/stylable/spacing.st.css.js';
export const DIRECTION = {
    horizontal: 'horizontal',
    vertical: 'vertical',
};
export const HORIZONTAL_ALIGNMENT = {
    left: 'left',
    center: 'center',
    right: 'right',
    'space-between': 'space-between',
};
export const VERTICAL_ALIGNMENT = {
    top: 'top',
    middle: 'middle',
    bottom: 'bottom',
    'space-between': 'space-between',
};
export const SPACING = {
    tiny: `${parseInt(stVars.Spacing)}px`,
    small: `${parseInt(stVars.Spacing) * 2}px`,
    medium: `${parseInt(stVars.Spacing) * 3}px`,
    large: `${parseInt(stVars.Spacing) * 4}px`,
};
//# sourceMappingURL=Box.constants.js.map